import { IPv6PrefixesCountSubscription } from "../../graphql/generated/operations";

/**
 *
 * @param {IPv6PrefixesCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.prefixesAggregate.aggregate?.count;
